import { Button, Nav } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import { UnitNavLink } from './UnitNavLink';
import useBreakpoint from 'utils/useBreakpoint';

const breakpointHeight = {
  xs: '744px',
  sm: '744px',
  md: '408px',
  lg: '408px',
  xl: '408px',
  xxl: '252px'
};

export const UnitSidebar = ({
  units,
  handleAddUnit,
  handleRemoveUnit,
  hideSidebar,
  setHideSidebar,
  setActiveUnit,
  activeUnitIndex
}) => {
  const breakpoint = useBreakpoint();

  return (
    <div
      className={classNames('chat-sidebar bg-white', {
        'start-0': hideSidebar
      })}
    >
      <div
        className="contacts-list"
        style={{
          overflowX: 'hidden'
        }}
      >
        <Flex
          className="chat-content-header align-items-center justify-content-between p-3"
          style={{ height: '68px' }}
        >
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '32px',
              height: '32px'
            }}
          >
            <FontAwesomeIcon icon="building" className="fs-2 text-700" />
          </div>

          <h5
            className="flex-1 ms-2 d-lg-block opacity-lg-100 ms-lg-2 fs-0 m-0 opacity-md-0 w-md-0 ms-md-0"
            style={{
              transition: 'all 0.3s ease-in'
            }}
          >
            Unidades
          </h5>

          <div
            className="text-700 d-md-none contacts-list-show cursor-pointer d-flex align-items-center fs-1"
            onClick={() => setHideSidebar(false)}
          >
            <FontAwesomeIcon icon="times" />
          </div>
        </Flex>

        <div className="position-relative w-100">
          <SimpleBarReact
            style={{
              height: breakpointHeight[breakpoint],
              minWidth: '65px',
              width: '100%',
              overflowX: 'hidden',
              transition: 'height 0.3s ease-in-out'
            }}
          >
            <Nav className="border-0">
              <div className="p-1 w-100 p-md-3 p-lg-0 mb-3">
                <Button
                  variant="outline-primary"
                  onClick={handleAddUnit}
                  className="w-100 d-md-none d-lg-inline-flex align-items-center justify-content-center gap-2 rounded-0 "
                >
                  <FontAwesomeIcon icon="plus" />

                  <span>Agregar unidad</span>
                </Button>

                <Button
                  variant="outline-primary"
                  onClick={handleAddUnit}
                  className="d-none d-md-flex d-lg-none p-0 justify-content-center align-items-center"
                  style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%'
                  }}
                >
                  <FontAwesomeIcon icon="plus" />
                </Button>
              </div>

              {units.length ? (
                units.map((unit, index) => (
                  <UnitNavLink
                    key={index}
                    unit={unit}
                    activeUnitIndex={activeUnitIndex}
                    setActiveUnit={setActiveUnit}
                    handleRemoveUnit={handleRemoveUnit}
                    index={index}
                  />
                ))
              ) : (
                <h5>No hay unidades</h5>
              )}
            </Nav>
          </SimpleBarReact>
        </div>
      </div>
    </div>
  );
};

UnitSidebar.propTypes = {
  units: PropTypes.array,
  handleAddUnit: PropTypes.func,
  handleRemoveUnit: PropTypes.func,
  hideSidebar: PropTypes.bool,
  setHideSidebar: PropTypes.func,
  setActiveUnit: PropTypes.func,
  activeUnitIndex: PropTypes.number
};
